// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"83e60e31","369":"c24fb81e","496":"c2dcac49","600":"1064330a","978":"de9de70b"}[chunkId] + ".chunk.css";
};